import { useTranslation } from "react-i18next";
import { NOTE_STATUS } from "@/services/api";
import { FormButtonSelect } from "@/shared/Components/Form/FormButtonSelect";
import styles from "./styles.module.scss";

export const StatusSelect = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <FormButtonSelect
        name={"currentNote.status"}
        placeholder="Select status"
        options={[
          { label: t("common.status.toDo"), value: NOTE_STATUS.TO_DO },
          { label: t("common.status.inProgress"), value: NOTE_STATUS.IN_PROGRESS },
          { label: t("common.status.done"), value: NOTE_STATUS.DONE },
        ]}
      />
    </div>
  );
};
